import {
    Checkbox,
    Flex,
    pxToRem,
    useAppDisplayModeContext,
    useStyles,
    useTheme,
} from '@archipro-design/aria';
import { TileTopActionButtonsMobile } from './TileTopActionButtons.mobile';
import * as S from './TileTopAction.style';
import TileTopActionButtonsDesktop from './TileTopActionButtons.desktop';
import { useDesignBoardPageState } from '../context';
import type { DetailedPinWithChecked } from '~/modules/design-board/component/all-pins/AllPins';
export const TileTopAction = ({
    isChecked,
    id,
    professionalLink,
    onUpdate,
    deletePin,
    isAllPins = false,
    isArticleTile = false,
    pin,
}: {
    isChecked: boolean;
    id: number;
    professionalLink?: string;
    onUpdate: (id: number, checked: boolean) => void;
    deletePin: (id: number) => void;
    isAllPins?: boolean;
    isArticleTile?: boolean;
    pin: DetailedPinWithChecked;
}): React.ReactElement => {
    const theme = useTheme();
    const { css } = useStyles();
    const { mobile } = useAppDisplayModeContext();
    const isAllowOrganise = mobile ? false : true; // todo: change it when implement the organise feature

    const { state } = useDesignBoardPageState();

    const canDelete = state.canEdit;
    const canComment = false; //hook up state.canComment when comment feature is implemented;

    return (
        <Flex className={css(S.TopActionWrapper)}>
            {isAllowOrganise && !isAllPins ? (
                <Checkbox
                    className={css(S.TopActionCheckbox)}
                    checked={isChecked}
                    indicator={{
                        kind: 'checkbox',
                        indicator: {
                            variables: {
                                iconSize: pxToRem(16),
                                border: `1px solid ${
                                    isChecked
                                        ? 'transparent'
                                        : theme.siteVariables.colors.grey[100]
                                }`,
                                backgroundColor: 'rgb(232, 233, 235)', //no color set for this
                                size: pxToRem(24),
                                checkedBackgroundColor:
                                    theme.siteVariables.colors.gold['000'],
                            },
                        },
                    }}
                    onChange={(e, data) => {
                        e.stopPropagation();
                        e.preventDefault();

                        onUpdate(id, data?.checked ?? false);
                    }}
                    key={`checkbox${id}`}
                />
            ) : (
                <div className={css(S.TopActionCheckbox)}></div>
            )}
            {mobile ? (
                <TileTopActionButtonsMobile
                    isArticleTile={isArticleTile}
                    pin={pin}
                />
            ) : (
                <div className={css(S.PinInteractionIcons)}>
                    <TileTopActionButtonsDesktop
                        professionalLink={professionalLink}
                        canDelete={canDelete}
                        onDelete={() => deletePin && deletePin(id)}
                        canComment={canComment}
                        pin={pin}
                    />
                </div>
            )}
        </Flex>
    );
};
